import { memo } from "react";
import MatchStandard from "./MatchStandard";
import MatchArena from "./MatchArena";
import MatchNone from "./MatchNone";

export const Match = ({ region, puuid, data, width }) => {
  return (
    <>
      {[1810, 1820, 1830, 1840].includes(data.queue) && (
        <MatchNone region={region} puuid={puuid} data={data} width={width} />
      )}
      {(data.queue === 1700 || data.queue === 1710) && (
        <MatchArena region={region} puuid={puuid} data={data} width={width} />
      )}
      {![1700, 1710, 1810, 1820, 1830, 1840].includes(data.queue) && (
        <MatchStandard
          region={region}
          puuid={puuid}
          data={data}
          width={width}
        />
      )}
    </>
  );
};

export default memo(Match);
